//Componentes generales
import React, { useState, useMemo, useEffect } from "react";
import { FixedSizeList } from "react-window";
import SearchInput from "../../components/searchInput/SearchInput";
import RenderRow from "../renderRows/RRProducts";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";

//Estilos
import './ProductList.css'
import AbmProducts from "../abmProducts/AbmProducts";
import { checkDoubleQuotes, removeDoubleQuotesFromFilter } from "../../utils/funciones";
import normalizeText from "../../utils/normalizeText";

/*
    Componente encargado de la vista de los productos disponibles.
        Donde productos es la lista de productos disponibles recuperados del context.
*/
function ProductList({productos = []}) {

    const navigate = useNavigate();
    
    //state de filtro.
    const [filter, setFilter] = useState("");
    const [productToEdit,setProductToEdit] = useState({});
    const [firstRender,setFirstRender] = useState(true);

    // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
    const listHeight = useMemo(() => window.innerHeight, []);

    /*
        Manejador ante cambios en filtro.
            Donde data es el texto ingresado por el usuario.
    */
    const handdlerSearchInput = (data) => {
        setFilter(data);
    }

    let productsFiltered = useMemo(()=> productos.filter(p => {
        return filter != '' ? 
            checkDoubleQuotes(filter) ?
            normalizeText(p.tipPro) == removeDoubleQuotesFromFilter(filter) || normalizeText(p.artCod) == removeDoubleQuotesFromFilter(filter) || normalizeText(p.descrp) == removeDoubleQuotesFromFilter(filter) || normalizeText(p.codRed) == removeDoubleQuotesFromFilter(filter)
            :
            normalizeText(p.tipPro).includes(normalizeText(filter)) || normalizeText(p.artCod).includes(normalizeText(filter)) || normalizeText(p.descrp).includes(normalizeText(filter)) || normalizeText(p.codRed).includes(normalizeText(filter))
        : true
    }), [productos, filter]);

    return (
        <div className="productsListDiv">
            <SearchInput buscar={handdlerSearchInput} filter={filter}/>
            <button style={{cursor:'pointer'}} onClick={()=>navigate('/abms')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
            <div className='container-product-list'>
                <FixedSizeList
                    height={listHeight}
                    itemCount={ productsFiltered.length}
                    itemSize={80}
                    width={"100%"}
                    >
                         {({ index, style }) => (
                            <RenderRow 
                                index={index} 
                                style={style}
                                productos={productsFiltered} 
                                filter={filter} 
                                setProductToEdit={setProductToEdit}
                            />
                        )}
                </FixedSizeList>
            </div>
            {Object.keys(productToEdit).length > 0 && <AbmProducts prodToEdit={productToEdit} setProductToEdit={setProductToEdit}/>}
        </div>
    );
}

export default ProductList